import { type Currency } from '@mos/shared/types'

export const BankOfferExtraCurrencyTypes = {
	KEYS: 'keys',
	FREE_ONCE: 'free_once',
	ADVERTISEMENT: 'advertisement',
} as const

export type BankOfferCurrencyType =
	| (typeof BankOfferExtraCurrencyTypes)[keyof typeof BankOfferExtraCurrencyTypes]
	| Currency

export function isFreebie(currency: BankOfferCurrencyType) {
	return currency === BankOfferExtraCurrencyTypes.FREE_ONCE || currency === BankOfferExtraCurrencyTypes.ADVERTISEMENT
}

export function isPremium(currency: BankOfferCurrencyType) {
	return !Object.values<string>(BankOfferExtraCurrencyTypes).includes(currency)
}
